import React from 'react';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';

/**
 * Common form fields shared across all service request forms
 * Includes customer info, date/time preferences, and urgency selection
 */
const CommonFormFields = ({ formData, setFormData }) => {
  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Your Name *</label>
          <Input
            value={formData.customer_name || ''}
            onChange={(e) => updateField('customer_name', e.target.value)}
            placeholder="Full name"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Phone Number *</label>
          <Input
            value={formData.customer_phone || ''}
            onChange={(e) => updateField('customer_phone', e.target.value)}
            placeholder="(555) 123-4567"
            required
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium mb-2">Email (Optional)</label>
        <Input
          type="email"
          value={formData.customer_email || ''}
          onChange={(e) => updateField('customer_email', e.target.value)}
          placeholder="your@email.com"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">Preferred Date *</label>
          <Input
            type="date"
            value={formData.preferred_date || ''}
            onChange={(e) => updateField('preferred_date', e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Preferred Time Window</label>
          <select
            value={formData.preferred_time_window || ''}
            onChange={(e) => updateField('preferred_time_window', e.target.value)}
            className="w-full p-3 border rounded-xl"
          >
            <option value="">Select time window</option>
            <option value="morning">Morning (8am-12pm)</option>
            <option value="afternoon">Afternoon (12pm-5pm)</option>
            <option value="evening">Evening (5pm-8pm)</option>
            <option value="flexible">Flexible</option>
          </select>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium mb-2">Urgency Level</label>
        <div className="flex gap-2">
          {['standard', 'priority', 'urgent'].map(level => (
            <Button
              key={level}
              type="button"
              variant={formData.urgency === level ? 'default' : 'outline'}
              onClick={() => updateField('urgency', level)}
              className={formData.urgency === level ? 
                (level === 'urgent' ? 'bg-[var(--error)]' : level === 'priority' ? 'bg-amber-500' : 'bg-[var(--success)]') : ''}
            >
              {level.charAt(0).toUpperCase() + level.slice(1)}
            </Button>
          ))}
        </div>
      </div>
    </>
  );
};

export default CommonFormFields;
